/**
 * SD.js scans for links that include the data-sda-event attribute once, when the
 * page loads. If additional links are added dynamically to the page later, you
 * can use the sd(‘trackLinks’) command to instruct SD.js to scan the page again
 * and enable support for the links that were added.
 */
import { useEffect } from 'react';

export default function useScanNewInteractiveElements() {
  useEffect(() => {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) {
          return;
        }

        const shouldScan = [...mutation.addedNodes].some(node => {
          if (
            node.nodeType !== Node.ELEMENT_NODE ||
            !(node instanceof Element)
          ) {
            return false;
          }

          return node.tagName === 'A' || node.querySelectorAll('a').length > 0;
        });

        if (shouldScan) {
          window.sd?.('trackLinks');
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      observer.disconnect();
    };
  }, []);
}
